import { MobilePerformanceBenchmark, MobileIncident } from '../services/mobile/offlineDataTypes';

export const MOBILE_EXECUTIVE_METRICS = {
  activeMobileUsersMonthly: '482,900',
  mobileSharePct: 76.4,
  pwaInstallAdoptionPct: 14.8,
  standaloneReturnRatePct: 41.2,
  dailyOfflineCalculations: '14,850',
  offlineCalculationAccuracyPct: 100.0,
  mobileCalculationCompletionRatePct: 94.6,
  p95MobileLatencyMs: 240,
  mobileCWVPassRatePct: 98.2,
  activePushSubscriptions: '38,400',
  syncFailureRatePct: 0.04,
  activeServiceWorkerVersion: 'v1.19.0'
};

export const MOBILE_PERFORMANCE_BENCHMARKS: MobilePerformanceBenchmark[] = [
  {
    deviceTier: 'LOW_END_ANDROID',
    lcpMs: 1450,
    inpMs: 78,
    clsScore: 0.012,
    ttfbMs: 310,
    jsBundleKb: 180,
    totalRequests: 8,
    cwvPass: true
  },
  {
    deviceTier: 'MID_RANGE',
    lcpMs: 890,
    inpMs: 42,
    clsScore: 0.005,
    ttfbMs: 180,
    jsBundleKb: 180,
    totalRequests: 8,
    cwvPass: true
  },
  {
    deviceTier: 'IOS_STANDARD',
    lcpMs: 640,
    inpMs: 28,
    clsScore: 0.002,
    ttfbMs: 140,
    jsBundleKb: 180,
    totalRequests: 8,
    cwvPass: true
  },
  {
    deviceTier: 'HIGH_END',
    lcpMs: 480,
    inpMs: 18,
    clsScore: 0.001,
    ttfbMs: 95,
    jsBundleKb: 180,
    totalRequests: 8,
    cwvPass: true
  }
];

export const OS_PLATFORM_MATRIX = [
  {
    platform: 'Android (Chrome / Chromium)',
    osVersion: 'Android 12 - 15',
    marketSharePct: 54.2,
    pwaInstall: 'FULL_NATIVE_PROMPT',
    serviceWorker: 'FULL_SUPPORT',
    backgroundSync: 'SUPPORTED',
    push: 'WEB_PUSH_VAPID',
    badging: 'SUPPORTED',
    webShare: 'SUPPORTED',
    status: 'OPTIMIZED'
  },
  {
    platform: 'iOS / iPadOS (Safari WebKit)',
    osVersion: 'iOS 17.0 - 18.x',
    marketSharePct: 38.6,
    pwaInstall: 'ADD_TO_HOME_SCREEN',
    serviceWorker: 'FULL_SUPPORT',
    backgroundSync: 'FOREGROUND_FALLBACK',
    push: 'WEB_PUSH_STANDALONE',
    badging: 'SUPPORTED_PWA',
    webShare: 'SUPPORTED',
    status: 'OPTIMIZED'
  },
  {
    platform: 'Android (Samsung Internet)',
    osVersion: 'v23.0+',
    marketSharePct: 4.8,
    pwaInstall: 'FULL_NATIVE_PROMPT',
    serviceWorker: 'FULL_SUPPORT',
    backgroundSync: 'SUPPORTED',
    push: 'WEB_PUSH_VAPID',
    badging: 'SUPPORTED',
    webShare: 'SUPPORTED',
    status: 'OPTIMIZED'
  },
  {
    platform: 'Android / iOS (Firefox Mobile)',
    osVersion: 'v128+',
    marketSharePct: 2.4,
    pwaInstall: 'MENU_INSTALL',
    serviceWorker: 'FULL_SUPPORT',
    backgroundSync: 'FOREGROUND_FALLBACK',
    push: 'WEB_PUSH_VAPID',
    badging: 'UNSUPPORTED',
    webShare: 'SUPPORTED',
    status: 'COMPATIBLE'
  }
];

export const MOBILE_INCIDENTS: MobileIncident[] = [
  {
    id: 'inc-mob-104',
    type: 'IOS_COMPATIBILITY',
    severity: 'MODERATE_P2',
    description: 'Safari WebKit safe-area inset compensation on iPhone 16 dynamic island.',
    affectedPlatform: 'iOS 18 Safari',
    status: 'RESOLVED',
    detectedAt: new Date(Date.now() - 1000 * 60 * 60 * 36).toISOString(),
    mitigationAction: 'Added env(safe-area-inset-top) and padding-fit wrapper.'
  },
  {
    id: 'inc-mob-103',
    type: 'STALE_FINANCIAL_CACHE',
    severity: 'CRITICAL_P0',
    description: 'Guaranteed prevention of stale FX rate presentation as live rate offline.',
    affectedPlatform: 'Service Worker Runtime Cache',
    status: 'RESOLVED',
    detectedAt: new Date(Date.now() - 1000 * 60 * 60 * 72).toISOString(),
    mitigationAction: 'Enforced explicit Offline / Cached Rate metadata badge and timestamp.'
  }
];
